import React, { Component, ReactNode } from 'react';
import { Settings } from 'react-slick';
import clsx from 'clsx';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

import AutoPlaySlickRow from './AutoPlaySlickRow';

export const styles = (theme) => ({
  root: {
    marginLeft: theme.spacing(-1),
    marginRight: theme.spacing(-1),
  },
  card: {
    margin: theme.spacing(2, 0.5),
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(2, 1),
    },
  },
});

export type Props = {
  classes: { [key: string]: string };
  theme: Theme;
};

class ListSlick extends Component<Props> {
  settings: (theme: Theme) => Settings = () => ({});

  slickItemsRenderer(): ReactNode {
    return <div />;
  }

  render() {
    const { classes, theme } = this.props;
    return (
      <AutoPlaySlickRow
        settings={this.settings(theme)}
        className={clsx(classes.root, 'service-list-slick')}
      >
        {this.slickItemsRenderer()}
      </AutoPlaySlickRow>
    );
  }
}

export default ListSlick;
